import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/base/services/base.service";
import { QrObra } from "../models/qr-obra.model";

@Injectable()
export class QrObrasService extends BaseService<QrObra> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getListFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }

  public getListCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }

  public getVerifyProject(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/verify-project', obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/qrobras/obras';
  }
}